"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2020 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOfDaysBetweenTwoDates = exports.isValidDate = exports.dateFormat = void 0;
/**
 * @description: Utility for formatting dates
 */
const moment_1 = __importDefault(require("moment"));
moment_1.default.locale('en');
/**
 * Formats the date as per the pattern supplied.
 * ---------------------------------------------------------
 * | pattern                | return value                  |
 * |--------------------    |-------------------------------|
 * | short                  | Nov 27, 2019                  |
 * | long                   | November 27, 2019             |
 * | custom eg MM-DD-YYYY   | 11-27-2019                    |
 * | undefined              | 11/27/2019                    |
 * ----------------------------------------------------------
 *
 * @param dateToFormat: string
 * @param pattern: string
 * @param parsePattern: string
 */
function dateFormat(dateToFormat, formatPattern, parsePattern) {
    let formattedDate = '';
    if (dateToFormat) {
        if (formatPattern) {
            if (formatPattern === 'short') {
                formattedDate = (0, moment_1.default)(String(dateToFormat), parsePattern).format('ll');
            }
            else if (formatPattern === 'long') {
                formattedDate = (0, moment_1.default)(String(dateToFormat), parsePattern).format('LL');
            }
            else {
                formattedDate = (0, moment_1.default)(String(dateToFormat), parsePattern).format(formatPattern);
            }
        }
        else {
            formattedDate = (0, moment_1.default)(String(dateToFormat), parsePattern).format('MM/DD/YYYY');
        }
    }
    return formattedDate;
}
exports.dateFormat = dateFormat;
/**
 * Checks if the date is a valid or not.
 * returns false - if an empty string or null is passed
 * returns false - if an empty expectedFormat is passed
 *
 * Currently only 2 formats (expectedFormat) are supported
 * - MM/DD/YYYY
 * - MM-DD-YYYY
 *
 * Examples:
 * - isValidDate('12/31/2021', 'MM/DD/YYYY') - will return true
 * - isValidDate('12-31-2021', 'MM-DD-YYYY') - will return true
 * - isValidDate('02-28-2021', 'MM-DD-YYYY') - will return true
 *
 * - isValidDate('2021/12/31', 'MM/DD/YYYY') - will return false
 * - isValidDate('aa/bb/2021', 'MM/DD/YYYY') - will return false
 *
 * @param date, the Date value as a string
 * @param expectedFormat, the expected format in which the data should be
 * @returns {boolean}, true if is a valid date
 */
function isValidDate(date, expectedFormat = 'MM/DD/YYYY') {
    if (!date || date === null || date.trim().length === 0) {
        return false;
    }
    return (0, moment_1.default)(date, expectedFormat, true).isValid();
}
exports.isValidDate = isValidDate;
/**
 * Get count of days between start date and end Date
 * Returns count of day difference by given startdate and enddate
 * @param startDate the, date value
 * @param endDate,the date value
 * @returns {number} - count of days differnece
 */
function getNumberOfDaysBetweenTwoDates(startDate, endDate) {
    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;
    // Calculating the time difference between two dates
    const diffInTime = endDate.getTime() - startDate.getTime();
    const diffInDays = Math.round(diffInTime / oneDay);
    return diffInDays;
}
exports.getNumberOfDaysBetweenTwoDates = getNumberOfDaysBetweenTwoDates;
//# sourceMappingURL=index.js.map